import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, FormGroup, Input } from 'reactstrap';

class PerPage extends Component {
    handleChange = ({target : { value }}) => {
        const { auth , fetch } = this.props;
        fetch(auth.token,{page:1, per_page: value});
    };

    render(){
        const { meta: { perPage } } = this.props;
        return (
            <Form inline>
                <FormGroup>
                    <Input className="mr-1" style={{minWidth: "100px"}} type="select" value={perPage} onChange={this.handleChange}><option>15</option><option>30</option><option>50</option><option>100</option></Input>
                </FormGroup>
            </Form>
            );
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps)(PerPage);


// WEBPACK FOOTER //
// ./src/Components/App/Layout/PerPage.js